export default __webpack_public_path__ + "static/media/Indiscriminate Shots.418cd2b8.png";